let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2OcM6")).then(() => parcelRequire('9at9H'));